var _line, _line2, _path, _path2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Document144(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 38,
    height: 38,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    x2: 30.5,
    y1: 22.5,
    y2: 22.5,
    fill: "none",
    stroke: "#F00",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    x2: 26.5,
    y1: 29.5,
    y2: 29.5,
    fill: "none",
    stroke: "#F00",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M22.1,42.5h13.4c1.7,0,3-1.3,3-3v-25h-7c-1.1,0-2-0.9-2-2v-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M24,5.5H12.5c-1.7,0-3,1.3-3,3v31c0,1.7,1.3,3,3,3h3.9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 29.5,
    y1: 14.5,
    y2: 5.5,
    fill: "none",
    stroke: "#F00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Document144);
export default __webpack_public_path__ + "static/media/icons8-document-144.e8cf13327d979de39da3228d57a27f15.svg";
export { ForwardRef as ReactComponent };